module.exports = __webpack_public_path__ + "img/severAF.bf40eb41.png";